import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { StyledTableContainerProps, TableContainerProps, TableProps } from './types'
import { OutlineIconButton } from 'components/v2/IconButton'

export const StyledTableContainer = styled.div<StyledTableContainerProps>`
  width: 100%;

  ${({ hasOverflow }): string => {
    if (hasOverflow) {
      return `
        padding-bottom: 400px;
        margin-bottom: -400px;
        overflow: auto;
      `
    }
    return ''
  }};
`

export const TableContainer = ({ overflow, children, ...props }: TableContainerProps): ReactElement => {
  return (
    <StyledTableContainer hasOverflow={overflow} {...props}>
      {children}
    </StyledTableContainer>
  )
}

export const Table = styled.table<TableProps>`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: ${(props): string => (props.marginBottom ? '50px' : '0px')};
`

export const Thead = styled.thead``

export const Th = styled.th<{ noUppercase?: boolean; noPaddingTop?: boolean; noWidth?: boolean }>`
  width: ${({ noWidth }): string => (noWidth ? '0' : 'auto')};
  padding: ${({ noPaddingTop }): string => (noPaddingTop ? '0 8px 16px' : '16px 8px')};
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px solid #b0b0b0;
  text-transform: ${({ noUppercase }): string => (noUppercase ? 'inherit' : 'uppercase')};
  color: #717171;
  :first-child {
    padding: ${({ noPaddingTop }): string => (noPaddingTop ? '0 8px 16px 4px' : '16px 8px 16px 4px')};
  }
`

export const BorderedTh = styled(Th)`
  border: 1px solid #eae9e9;
  padding: 16px;
  font-size: 16px;

  :first-child {
    padding: 16px;
  }
`

export const Tbody = styled.tbody``

export const Tr = styled.tr<{ isSelected?: boolean; readOnly?: boolean }>`
  :nth-child(even) {
    td {
      ${({ readOnly }): string => (readOnly ? 'background-color: #F8F8F8;' : '')}
    }
  }

  td {
    background-color: ${({ isSelected }): string => (isSelected ? 'rgba(143, 139, 255, 0.35)' : '#fff')};
    ${({ readOnly }): string => (readOnly ? 'border-bottom: none;' : '')}
    ${({ isSelected }): string => {
      if (isSelected) {
        return `
          ${OutlineIconButton} {
            &:focus {
              background-color: #8f8bff;
              border: none;
              padding: 11px 4px;
      
              svg {
                fill: #ffffff;
              }
            }
          }
        `
      }
      return ''
    }}
  }

  :hover {
    td {
      ${({ isSelected, readOnly }): string => (isSelected || readOnly ? '' : 'background-color: #EAEAFF;')}
    }
  }
`

export const Td = styled.td<{ top?: boolean }>`
  padding: 16px 8px 16px;
  vertical-align: ${({ top }): string => (top ? 'top' : 'middle')};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #28265d;
  border-bottom: 1px solid #e3e3e3;

  :first-child {
    padding: 16px 8px 16px 4px;
  }
`

export const BorderedTd = styled(Td)`
  border: 1px solid #eae9e9;
  padding: 16px;
  font-size: 16px;

  :first-child {
    padding: 16px;
  }
`

export const TdId = styled(Td)`
  font-weight: 500;
`

export const IdWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 85px;
`

export const EmptyTd = styled.td`
  padding-bottom: 16px;
`
